var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosterMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.81,
    height: 442.015,
    viewBox: "0 0 163.81 442.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#543326;}.b{fill:#fff;}.c{fill:#3c465c;}.d{fill:#455da5;}.e{fill:#d4d4d4;}.e,.h{mix-blend-mode:multiply;isolation:isolate;}.f{fill:#c6914d;}.g{fill:#a36d4f;}.h{fill:#d9d9d9;}.i{fill:#8f5f45;}.j{fill:#5c392a;}.k{fill:#8f6d5f;}.l{fill:#ebebeb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220.056 -103.552)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.147,109.481c12.043-1.52,33.831,1.341,36.555,26.988,2.455,23.1-.11,61.7-19.794,65.612s-33.116,2.675-38.693-10.117S225.43,152.6,227.885,133.49C230.485,113.25,244.57,111.193,258.147,109.481Z",
    transform: "translate(42.347 32.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M263.615,118.2h0a6.477,6.477,0,0,1,3.528,7.111c-5.014,24.78-8.576,40.461-11.575,52.16-3.329,12.992-21.651,14.133-18.783,3.15,3.342-12.765,8.906-35.605,16.829-59.367C255.3,116.2,260.293,116.656,263.615,118.2Z",
    transform: "translate(96.542 79.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M236.334,151.545c1.19-6.52,7.359-20.633,9.787-27.951,1.2-3.611,16.651,1.912,16.252,4.966-4.278,22.772-7.38,33.79-17.1,35.8C240.488,165.348,234.725,160.314,236.334,151.545Z",
    transform: "translate(94.057 110.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M279.961,161.109c-1.231,25.488-51.534,24.587-51.534-.75V139.823h51.534Z",
    transform: "translate(49.199 213.185)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.74 366.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M230.8,149.315c.461-11.2,24.9-9.409,24.409,2.421-.268,20.99-3.3,46.726-7.29,74.113-.151,3.631-4.367,6.4-9.422,6.2h0c-5.055-.206-9.03-3.322-8.879-6.953C226.258,198.07,228.9,172.066,230.8,149.315Z",
    transform: "translate(-228.007 -141.816)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.62 366.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M256.768,149.315c-.461-11.2-24.9-9.409-24.409,2.421.268,20.99,3.3,46.726,7.29,74.113.151,3.631,4.367,6.4,9.422,6.2h0c5.055-.206,9.03-3.322,8.879-6.953C261.314,198.07,258.673,172.066,256.768,149.315Z",
    transform: "translate(-232.352 -141.816)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.1,118.2h0a6.477,6.477,0,0,0-3.528,7.111c5.014,24.78,8.576,40.461,11.575,52.16,3.329,12.992,21.658,14.133,18.783,3.15-3.343-12.765-8.907-35.605-16.829-59.367C235.424,116.2,230.424,116.656,227.1,118.2Z",
    transform: "translate(19.932 79.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250.914,152.295c-1.7-7.1-7.559-21.348-9.986-28.659-1.2-3.618-16.857.832-16.458,3.886,5.426,30.427,9.972,36.355,17.5,37.586C246.794,165.892,252.991,160.967,250.914,152.295Z",
    transform: "translate(25.894 110.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M293.925,242.01c0,5.371-53.109,3.858-53.109-1.513,0,0-.605-34.216-3.542-52.455-3.343-20.791-9.711-30.7-11.039-41.933-.509-4.34,8.136-18.122,12.448-18.845,16.128-2.71,41.995-3.012,57.593-.536,4.395.695,13.494,14.415,12.875,18.817-1.774,12.669-8.776,21.506-11.389,42.792C295.293,208.413,293.925,242.01,293.925,242.01Z",
    transform: "translate(36.191 126.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M233.337,125.548c-2.669,11.4-4.037,22.909-3.377,27.442.2,1.382,5.365,1.2,6.637,2s-5.633,3.735-4.567,5.64c1.486,2.662,11.823,25.076,13.329,25.475s16.107-25.99,15.874-27.036c-.385-1.719-5.33-2.613-5.2-4.085.076-.894,7.036-.763,7.036-2.49,0-2.3.268-16.912-2.7-27.187A243.133,243.133,0,0,0,233.337,125.548Z",
    transform: "translate(57.246 126.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M230.577,125.438c1.258,11.224,8.219,52.511,10.509,52.7,2.263.193,13.308-45.956,13.652-52.882C246.932,124.916,238.534,124.984,230.577,125.438Z",
    transform: "translate(61.836 126.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M237.765,135.662c1.348-.873,3.363-2.827,2.758-4.36-1.554-3.934-1.829-5.42-3.769-5.523-1.348-.069-2.338,1.327-3.975,5.523-.468,1.2.832,3.274,2.1,4.271-.894,6.733-2.462,18.48-3.315,25.674,1.527,7.228,2.93,12.51,3.741,12.579s2.84-6.107,5.069-14.271C239.608,152.636,238.4,141.591,237.765,135.662Z",
    transform: "translate(67.619 130.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M231.909,122.918c.825,4.133,1.073,14.615-.929,17.1,2.586,3.9,15.069,3.961,18.563-.11-1.142-2.235-2.387-11.376-.591-16.988C249.068,122.574,231.909,122.918,231.909,122.918Z",
    transform: "translate(64.205 112.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M247.27,130.944a25.234,25.234,0,0,1,.887-8.026c.117-.344-17.043,0-17.043,0a45.654,45.654,0,0,1,.605,8.281C235.833,132.519,241.383,132.45,247.27,130.944Z",
    transform: "translate(64.998 112.924)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.191 146.04)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M239.174,119.86c3.157-4.367,8.1-2.393,6.438,4.319-1.685,6.816-9.869,6.527-9.869,5.557S239.174,119.86,239.174,119.86Z",
    transform: "translate(-175.997 -63.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M234.18,119.812c-3.164-4.367-9.14-2.056-6.444,4.312,2.469,5.825,9.869,6.527,9.869,5.557S234.18,119.812,234.18,119.812Z",
    transform: "translate(-227.055 -63.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.441 6.447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M227.7,141.091c.069,14.285,3.177,42.469,8.281,51.733,4.952,8.982,39.938,10.062,45.378-.818s8.384-48.748,5.791-60.145-10.481-20.908-26.8-21.162S227.557,111.071,227.7,141.091Z",
    transform: "translate(-227.701 -110.667)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256.868,127.791c12.2-.117,29.629,3.274,32.036,31.9,5.1-33.941-11.884-49.959-32.249-49.959s-33.322,20.812-27.82,50.6C227.59,134.421,246.634,127.894,256.868,127.791Z",
    transform: "translate(-224.056 -109.73)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M236.193,123.019c0,3.329-1.479,6.025-3.3,6.025s-3.308-2.7-3.308-6.025,1.479-6.025,3.308-6.025S236.193,119.69,236.193,123.019Z",
    transform: "translate(55.993 79.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M240.186,123.019c0,3.329-1.479,6.025-3.3,6.025s-3.3-2.7-3.3-6.025,1.479-6.025,3.3-6.025S240.186,119.69,240.186,123.019Z",
    transform: "translate(79.51 79.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250.691,121.742c-.007,1.513-2.648,9.051-10.055,8.673a10.512,10.512,0,0,1-9.931-9C230.7,120.181,250.691,120.766,250.691,121.742Z",
    transform: "translate(62.588 100.887)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.79 181.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.818,125.217l-1.121-2.084a.838.838,0,0,1,.337-1.135l12.909-6.981a.838.838,0,0,1,1.135.337l1.128,2.084a.838.838,0,0,1-.337,1.135l-12.916,6.981A.838.838,0,0,1,229.818,125.217Z",
    transform: "translate(-228.596 -114.916)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.939 181.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M247.607,125.217l1.128-2.084A.838.838,0,0,0,248.4,122l-12.916-6.981a.83.83,0,0,0-1.128.337l-1.128,2.084a.838.838,0,0,0,.337,1.135l12.916,6.981A.83.83,0,0,0,247.607,125.217Z",
    transform: "translate(-233.125 -114.916)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M257.3,182.139l-29.5-.082a2.974,2.974,0,0,1-2.964-2.985v-.536a13.188,13.188,0,0,1,13.226-13.15l19.443.413c2.723.158,2.813,5.516,2.806,7.16l-.014,4.911C260.337,180.543,259.209,181.995,257.3,182.139Z",
    transform: "translate(28.046 363.428)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.904 442.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M243.691,244.387c-.144,2.5-15.942-1.52-15.8-4.023.475-28.659-.1-57.779,2.586-81.121.213-3.8,4.484-6.671,9.532-6.4h0c5.055.268,8.975,3.569,8.762,7.373C248.967,185.535,246.7,217.254,243.691,244.387Z",
    transform: "translate(-227.886 -152.822)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M237.336,182.139l29.5-.082a2.973,2.973,0,0,0,2.964-2.985v-.536a13.188,13.188,0,0,0-13.226-13.15l-19.443.413c-2.723.158-2.806,5.516-2.806,7.16l.014,4.911C234.3,180.543,235.431,181.995,237.336,182.139Z",
    transform: "translate(83.894 363.428)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.775 442.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M238.48,244.387c.144,2.5,15.942-1.52,15.8-4.023-.475-28.659.1-57.779-2.586-81.121-.213-3.8-4.484-6.671-9.532-6.4h0c-5.048.268-8.975,3.569-8.762,7.373C233.205,185.535,235.468,217.254,238.48,244.387Z",
    transform: "translate(-233.392 -152.822)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 46.473,
    height: 163.804,
    transform: "translate(383.861 103.552) rotate(89.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M242.624,133.282a22.218,22.218,0,0,0-2.455-10.426c-1.919-3.741-1.926-5.248-1.816-8.563.117-3.363,3.8-4.7,6.41-5.2,4.635-.887,9.2.082,9.8,3.459.722,4.071.619,6.7-1.045,9.567a15.881,15.881,0,0,0-2.208,10.117C251.579,135.277,242.617,135.352,242.624,133.282Z",
    transform: "translate(107.32 30.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M236.035,133.106a22.134,22.134,0,0,1,2.455-10.426c1.919-3.741,1.919-5.255,1.809-8.563-.11-3.363-3.8-4.7-6.41-5.2-4.635-.887-9.2.076-9.8,3.459-.715,4.072-.619,6.7,1.046,9.567a15.793,15.793,0,0,1,2.208,10.117C227.081,135.1,236.035,135.169,236.035,133.106Z",
    transform: "translate(21.219 29.702)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.267 155.189)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M240.074,111.871a1.618,1.618,0,0,0-1.52,1.678c.708,16.437,1.479,38.239,1.981,48.088a7.071,7.071,0,0,0,7.614,6.637h0a7.655,7.655,0,0,0,6.912-8.226c-.97-9.876-2.194-30.523-2.957-47.449a1.618,1.618,0,0,0-1.767-1.534Z",
    transform: "translate(-238.553 -111.06)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.382 155.627)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.043,111.124a1.613,1.613,0,0,1,1.678,1.671c-.695,16.458-1.211,38.652-1.706,48.466a7.081,7.081,0,0,1-7.62,6.637h0a7.655,7.655,0,0,1-6.912-8.226c.977-9.911,2.455-29.9,3.232-46.809a1.615,1.615,0,0,1,1.6-1.541Z",
    transform: "translate(-223.448 -111.124)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosterMan);
export default __webpack_public_path__ + "static/media/poster-man.b28ae90ee4f28f561100e57ad8aaa838.svg";
export { ForwardRef as ReactComponent };